import React from "react";
export const StoriesContext = React.createContext();
